import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const SummaryLoadable = Loadable({
    loader: () => import('desktop/containers/Summary/Summary.js' /* webpackChunkName: 'summary' */).then(module => module.default),
    loading: () => <Loader />
});

export default SummaryLoadable;
